export default __webpack_public_path__ + "static/dont-animate-too-many-45e49344e39f47860a9b4308d1a38a8f.png";